module.exports = __webpack_public_path__ + "static/img/产品介绍页.f9b1c89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/产品介绍页.jpg
// module id = H6mJ
// module chunks = 1